import { IAction, isType } from '@zaibot/fsa';
import OPEN_DROPDOWN_STATUS from './action/OPEN_DROPDOWN_STATUS';
import { IQuestionDB } from '../../types';
import QUESTION_ITEM_LAST_TOUCHED from './action/QUESTION_ITEM_LAST_TOUCHED';
import QUESTION_INSPECT from './action/QUESTION_INSPECT';
import QUESTION_LINK from './action/QUESTION_LINK';
import QUESTION_CHANGE_STATUS_BATCH from './action/QUESTION_CHANGE_STATUS_BATCH';
import QUESTION_CHANGE_STATUS_BATCH_CANCEL from './action/QUESTION_CHANGE_STATUS_BATCH_CANCEL';
import QUESTION_CHANGE_STATUS_BATCH_COMPLETE from './action/QUESTION_CHANGE_STATUS_BATCH_COMPLETE';
import QUESTION_CHANGE_STATUS_BATCH_FAILURE from './action/QUESTION_CHANGE_STATUS_BATCH_FAILURE';
import QUESTION_CHANGE_STATUS_BATCH_START from './action/QUESTION_CHANGE_STATUS_BATCH_START';
import { IStatusType, statusNieuw, statusses } from './authmodule/authcheck';
import QUESTION_APPLY_STATUS_BATCH from './action/QUESTION_APPLY_STATUS_BATCH';
import QUESTION_SAVE from './action/QUESTION_SAVE';
import QUESTION_SHOWLINKS from './action/QUESTION_SHOWLINKS';
import QUESTION_MAXIMIZE from './action/QUESTION_MAXIMIZE';
import QUESTION_SEARCH_TERM_LINK from './action/QUESTION_SEARCH_TERM_LINK';
import OPEN_DROPDOWN_PRACTICIONER from './action/OPEN_DROPDOWN_PRACTICIONER';

interface IState {
  dropdownopen: boolean;
  dropdownopenPracticioner: boolean;
  questionselected: IQuestionDB;
  inspect: IQuestionDB;
  linkvisible: boolean;
  linkitem: IQuestionDB;
  showlinks: boolean;
  showitem: IQuestionDB;
  searchTermLinking: string;
  batchchange: boolean;
  batchstatus: IStatusType;
  maximized: boolean;
}
const emptyState: IState = {
  dropdownopen: false,
  dropdownopenPracticioner: false,
  questionselected: {} as IQuestionDB,
  inspect: {} as IQuestionDB,
  linkvisible: false,
  linkitem: {} as IQuestionDB,
  showlinks: false,
  showitem: {} as IQuestionDB,
  searchTermLinking: '',
  batchchange: false,
  batchstatus: statusses.qFirst((itm) =>itm.id===statusNieuw),
  maximized: false,
};

export const selector = (state: any) => state.questionReducer as IState;

export const reducer = (state = emptyState, action: IAction) => {
  if (isType(action, OPEN_DROPDOWN_STATUS)) {   
    return { ...state, dropdownopen: action.payload.dropdownopen };
  } 
  if (isType(action, OPEN_DROPDOWN_PRACTICIONER)) {   
    return { ...state, dropdownopenPracticioner: action.payload.dropdownopenPracticioner };
  }   
  if (isType(action, QUESTION_ITEM_LAST_TOUCHED)) {   
    return { ...state, questionselected: action.payload.item  };
  }
  if (isType(action, QUESTION_INSPECT)) {
    return { ...state, inspect: action.payload.item};
  } 
  if (isType(action, QUESTION_LINK)) {
    return { ...state, linkvisible: action.payload.linkvisible, 
                       linkitem: action.payload.linkitem};
  } 
  if (isType(action, QUESTION_SHOWLINKS)) {
    return { ...state, showlinks: action.payload.showlinks,
                       showitem: action.payload.showitem};
  }   
  if (isType(action, QUESTION_SAVE)) {
    return { ...state, saveitem: action.payload.saveitem  };
  }
  if (isType(action, QUESTION_CHANGE_STATUS_BATCH)) {
    return { ...state, items: action.payload.items, batchstatus: action.payload.batchstatus, batchchange: action.payload.batchchange};
  }   
  if (isType(action, QUESTION_CHANGE_STATUS_BATCH_COMPLETE)) {
    return { ...state, items: undefined, batchstatus: action.payload.batchstatus, batchchange: false};
  }   
  if (isType(action, QUESTION_CHANGE_STATUS_BATCH_FAILURE)) {
    return { ...state, items: undefined, batchstatus: action.payload.batchstatus, batchchange: false};
  }  
  if (isType(action, QUESTION_APPLY_STATUS_BATCH)) {
    return { ...state, items: action.payload.items, batchstatus: action.payload.batchstatus, batchchange: true};
  }    
  if (isType(action, QUESTION_CHANGE_STATUS_BATCH_CANCEL)) {
    return { ...state, items: undefined, batchstatus: action.payload.batchstatus, batchchange: false};
  }  
  if (isType(action, QUESTION_CHANGE_STATUS_BATCH_START)) {
    return { ...state, items: action.payload.items, batchstatus: action.payload.batchstatus, batchchange: true};
  }  
  if (isType(action, QUESTION_MAXIMIZE)) {
    return { ...state, maximized: action.payload.maximized};
  }
  if (isType(action, QUESTION_SEARCH_TERM_LINK)) {
    return { ...state, searchTermLinking: action.payload.searchTermLinking };
  }
  return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/reducer.tsx